/* eslint-disable eqeqeq */
import {
  CmpSelectBox,
  CmpTextField,
  CmpTextFieldEnter,
  CmpButton,
} from "../../Component/Common/ToolBox/ToolBox";
import React, { useState, useEffect, useRef } from "react";
// import { Box, Grid } from '@mui/material';
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import { fExecuteAPI } from "../../Server/Apis";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { fAlertToast, GetGitterColumns } from "../../Utility/Utilitys";
import { confirmAlert } from "react-confirm-alert"; // Import
// import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import useMediaQuery from "@mui/material/useMediaQuery";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

import "./salesgroup.css";
import {
  GridDataColumnsSalesGroupModal_Def,
  GridDataColumnsEmployeeModal_Def,
} from "./SalesGroupAction";
import GCEmployee from "../../Component/Common/ReuseableComponent/GCEmployee";
import GCVanMaster from "../../Component/Common/ReuseableComponent/GCVanMaster";

export default function SalesGroupUpdate() {
  const vMediaQuery = useMediaQuery("(max-width:450px)");
  const scanFocusOnLoad = useRef(null);
  // const vRdxDetail = useSelector((state) => state.SliceLoading.value.LoadingHead);
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const [sSalesGroup, setSalesGroup] = useState([]); //sSalesGroup Select
  const [sEnterKeyObj, setEnterKeyObj] = useState({
    key: "Enter",
  });
  const [sDetail, setDetail] = useState({
    Scan: "",
    VocType: "",
    VocName: "",
    VocNo: "",
    LocCode: "",
    LocName: "",
    BrCode: "",
    BrName: "",
    SalesGroup: "",
    SalesGroupCode: "",
    LoadingStatus: "",
    DocStatus: "",
  });
  let vDetailObjInit = {
    Scan: "",
    VocType: "",
    VocName: "",
    VocNo: "",
    LocCode: "",
    LocName: "",
    BrCode: "",
    BrName: "",
    SalesGroup: "",
    SalesGroupCode: "",
    LoadingStatus: "",
    DocStatus: "",
  };
  const [sErrorMsg, setErrorMsg] = useState({
    Scan: "",
    VocType: "",
    VocName: "",
    VocNo: "",
    LocCode: "",
    LocName: "",
    BrCode: "",
    BrName: "",
    SalesGroup: "",
    SalesGroupCode: "",
    LoadingStatus: "",
    DocStatus: "",
  });

  let vErrorInit = {
    Scan: "",
    VocType: "",
    VocName: "",
    VocNo: "",
    LocCode: "",
    LocName: "",
    BrCode: "",
    BrName: "",
    SalesGroup: "",
    SalesGroupCode: "",
    LoadingStatus: "",
    DocStatus: "",
  };

  const fOnChangeInput = (e) => {
    setDetail((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fOnKeyUp = async (e) => {
    setErrorMsg(vErrorInit);
    if (e.key === "Enter") {
      let vScanCodeResult = await GetCartBarcodeDetail(sDetail.Scan);
      if (vScanCodeResult.length > 0) {
        const vSalesGroup = await GetSalesGroups(vScanCodeResult[0].LocCode);
        if (vSalesGroup.length > 0) {
          setDetail((obj) => ({
            ...obj,
            SalesGroup: vScanCodeResult[0].SalesGroupName,
            SalesGroupCode: vScanCodeResult[0].SalesGroupCode,
          }));
        }
      }
    } else if (e.key === "Backspace" || e.keyCode === 8) {
      setDetail({
        Scan: sDetail.Scan,
        VocType: "",
        VocName: "",
        VocNo: "",
        LocCode: "",
        LocName: "",
        BrCode: "",
        BrName: "",
        SalesGroup: "",
        SalesGroupCode: "",
        LoadingStatus: "",
        DocStatus: "",
      });
    } else if (
      e.key === "Delete" ||
      e.keyCode === 46 ||
      e.key === "Backspace"
    ) {
      if (sDetail.Scan == "") {
        setDetail((obj) => ({
          ...obj,
          VocType: "",
          VocName: "",
          VocNo: "",
          LocCode: "",
          LocName: "",
          BrCode: "",
          BrName: "",
          SalesGroup: "",
          SalesGroupCode: "",
          LoadingStatus: "",
          DocStatus: "",
        }));
      }
    }
  };

  const fSalesGroupSelect = (e) => {
    let vSalesGroup = sSalesGroup.find((obj) => {
      return obj.UId == e.target.value;
    });
    setDetail((obj) => ({
      ...obj,
      SalesGroupCode: vSalesGroup.UId,
      SalesGroup: vSalesGroup.Name1,
    }));
  };

  const setValidation = () => {
    let iRes = true;
    if (sDetail.Scan === "") {
      setErrorMsg((obj) => ({ ...obj, Scan: "Scan is Empty" }));
      iRes = false;
    }
    if (sDetail.VocType === "") {
      setErrorMsg((obj) => ({ ...obj, VocType: "VocType is Empty" }));
      iRes = false;
    }
    if (sDetail.VocName === "") {
      setErrorMsg((obj) => ({ ...obj, VocName: "VocName is Empty" }));
      iRes = false;
    }
    if (sDetail.VocNo === "") {
      setErrorMsg((obj) => ({ ...obj, VocNo: "VocNo is Empty" }));
      iRes = false;
    }

    if (sDetail.LocCode === "") {
      setErrorMsg((obj) => ({ ...obj, LocCode: "LocCode is Empty" }));
    }
    if (sDetail.LocName === "") {
      setErrorMsg((obj) => ({ ...obj, LocName: "LocName is Empty" }));
      iRes = false;
    }
    if (sDetail.BrCode === "") {
      setErrorMsg((obj) => ({ ...obj, BrCode: "BrCode is Empty" }));
      iRes = false;
    }
    if (sDetail.BrName === "") {
      setErrorMsg((obj) => ({ ...obj, BrName: "BrName is Empty" }));
      iRes = false;
    }
    if (sDetail.SalesGroup === "") {
      setErrorMsg((obj) => ({ ...obj, SalesGroup: "SalesGroup is Empty" }));
      iRes = false;
    }
    if (sDetail.SalesGroupCode === "") {
      setErrorMsg((obj) => ({
        ...obj,
        SalesGroupCode: "SalesGroupCode is Empty",
      }));
      iRes = false;
    }
    if (sDetail.LoadingStatus === "") {
      setErrorMsg((obj) => ({
        ...obj,
        LoadingStatus: "LoadingStatus is Empty",
      }));
      iRes = false;
    }
    if (sDetail.DocStatus === "") {
      setErrorMsg((obj) => ({ ...obj, DocStatus: "DocStatus is Empty" }));
      iRes = false;
    }

    return iRes;
  };
  const fNew = (e) => {
    setDetail(vDetailObjInit);
    setSalesGroup([]);
    setErrorMsg(vErrorInit);
    scanFocusOnLoad.current?.focus();
  };

  const fUpdate = (e) => {
    setErrorMsg(vErrorInit);
    if (setValidation()) {
      GetUpdate();
    }
  };

  //Sales Group Modal
  const [sSaleGroupTypeArr, setSaleGroupTypegArr] = useState([
    { UId: "Supervisor", Name: "Supervisor" },
    { UId: "Driver", Name: "Driver" },
    { UId: "Salesman", Name: "Salesman" },
    { UId: "Helper", Name: "Helper" },
  ]);
  const [sSalesGroupModal, setSalesGroupModal] = useState(false);
  const [sSalesGroupModalObj, setSalesGroupModalObj] = useState({
    Group: "",
    SrNo: "0",
    Type: sSaleGroupTypeArr[0].UId,
    EmployeeID: "",
    EmployeeName: "",
    // Branch: "1",
    Active: "Y",
    // ImageUrl: "",
  });
  var vErrorMsgVanMasterInit = {
    SrNo: "",
    Type: "",
    EmployeeID: "",
    EmployeeName: "",
    Active: "",
  };
  const [sErrorMsgVanMaster, setErrorMsgVanMaster] = useState({
    SrNo: "",
    Type: "",
    EmployeeID: "",
    EmployeeName: "",
    Active: "",
  });

  const [sSalesGroupModalArr, setSalesGroupModalArr] = useState([]);
  const fGetVanMasterSearchEnter = (e) => {
    if (e.key == "Backspace") {
      setSalesGroupModalObj((obj) => ({
        ...obj,
        EmployeeID: "",
      }));
    }
    if (
      e._reactName === "onClick" ||
      (e.key == "Enter" && e.target.name == "EmployeeName")
    ) {
      fOpenSalesGroupEmployeeModal();
      setSalesGroupEmployeeModelObj((obj) => ({
        ...obj,
        AnyData: sSalesGroupModalObj.EmployeeName,
      }));
      if (sSalesGroupModalObj.EmployeeName !== "") {
        GetEmployeeSearchVanGroup(sSalesGroupModalObj.EmployeeName);
      }
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      var selectedLength =
        document.getElementsByClassName("Mui-selected").length;
      setTimeout(() => {
        if (selectedLength === 0) {
          let tabel = document.getElementById("table-main-grid-5");
          // vIsDownKeyPressedSimpleSearch = true;
          // tabel?.getElementsByClassName('MuiDataGrid-row')[0].firstChild.click();
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            .firstChild?.focus();
        }
      }, 200);
    }
  };

  //GCSimpleSearch Sales Group Modal
  const fVanMasterRowClick = (e) => {
    setSalesGroupModalObj((obj) => ({
      ...obj,
      SrNo: e?.row?.Srno,
      Type: e?.row?.Typ,
      EmployeeID: e?.row?.EMPID,
      EmployeeName: e?.row?.EMPNAME,
      Active: e?.row?.Active,
    }));
  };

  // Sales Group Modal
  const fVanMasterRowCellClick = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      setSalesGroupModalObj((obj) => ({
        ...obj,
        SrNo: newSelectionModel?.row?.Srno,
        Type: newSelectionModel?.row?.Typ,
        EmployeeID: newSelectionModel?.row?.EMPID,
        EmployeeName: newSelectionModel?.row?.EMPNAME,
        Active: newSelectionModel?.row?.Active,
      }));
    }
  };
  const fOnVanMasterSrNoModal = (e) => {
    setSalesGroupModalObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };
  const fOnVanMasterTypModal = (e) => {
    setSalesGroupModalObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };
  const fOnVanMasterActiveModal = (e) => {
    setSalesGroupModalObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.checked ? "Y" : "N",
    }));
  };
  const fOnVanMasterEmployeeModal = (e) => {
    setSalesGroupModalObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
    //IN MOBILE Backspace KEY NOT DETECTED TO CALL API WE USE BLUR
    if (
      e.target.value.length <
        sSalesGroupModalObj.EmployeeName.toString().length &&
      vMediaQuery &&
      e.target.name === "EmployeeName"
    ) {
      var vBackspaceObj = {
        key: "Backspace",
      };
      fGetVanMasterSearchEnter(vBackspaceObj);
    }
  };

  const fCloseSalesGroupModal = (e) => {
    setSalesGroupModal(false);
    fClearSalesGroupSearch();
  };

  const fClearSalesGroupSearch = () => {
    setSalesGroupModalObj((obj) => ({
      ...obj,
      Group: sDetail.SalesGroupCode,
      SrNo: "0",
      Type: sSaleGroupTypeArr[0].UId,
      EmployeeID: "",
      EmployeeName: "",
      // Branch: "1",
      Active: "Y",
      // ImageUrl: "",
    }));
    setSalesGroupModalArr([]);
    setErrorMsgVanMaster(vErrorMsgVanMasterInit);
  };
  const fNewSaleGroupModal = () => {
    fClearSalesGroupSearch();
    GetVANMastItemList();
  };
  const fValidationVanMasterSalesGroup = () => {
    let iRes = true;
    if (sSalesGroupModalObj.SrNo === "") {
      setErrorMsgVanMaster((obj) => ({
        ...obj,
        SrNo: "SrNo should not be empty",
      }));
      iRes = false;
    }
    if (sSalesGroupModalObj.Type === "") {
      setErrorMsgVanMaster((obj) => ({
        ...obj,
        Type: "Type should not be empty",
      }));
      iRes = false;
    }
    if (sSalesGroupModalObj.EmployeeID === "") {
      setErrorMsgVanMaster((obj) => ({
        ...obj,
        EmployeeID: "EmployeeID should not be empty",
      }));
      iRes = false;
    }
    if (sSalesGroupModalObj.EmployeeName === "") {
      setErrorMsgVanMaster((obj) => ({
        ...obj,
        EmployeeID: "EmployeeName should not be empty",
      }));
      iRes = false;
    }
    if (sSalesGroupModalObj.Active === "") {
      setErrorMsgVanMaster((obj) => ({
        ...obj,
        Active: "Active should not be empty",
      }));
      iRes = false;
    }
    return iRes;
  };
  let timeout = null;
  const fSaveSaleGroupModal = async () => {
    setErrorMsgVanMaster(vErrorMsgVanMasterInit);
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (fValidationVanMasterSalesGroup()) {
        GetVANMastItemSave();
      }
    }, 800);
  };
  const fDeleteSaleGroupModal = async () => {
    if (sSalesGroupModalObj.SrNo > 0) {
      confirmAlert({
        title: "Delete",
        message: "Are you want to delete.",
        buttons: [
          {
            className: "alertBtn",
            name: "DeletYes",
            label: "Yes",
            onClick: () => {
              GetVANMastItemDelete();
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
    }

    // GetVANMastItemDelete();
  };

  // Employee Modal
  const [sSalesGroupEmployeeModal, setSalesGroupEmployeeModal] =
    useState(false);
  const [sEmployeeSearchResultArr, setEmployeeSearchResultArr] = useState([]);
  const [sSalesGroupEmployeeModelObj, setSalesGroupEmployeeModelObj] = useState(
    {
      AnyData: "",
      FirstName: "",
      MiddleName: "",
      LastName: "",
    }
  );
  const fOpenSalesGroupEmployeeModal = () => {
    fClearEmployeeSearch();
    setTimeout(() => {
      document.getElementsByName("AnyData")[0]?.focus();
    }, 100);
    setSalesGroupEmployeeModal(true);
  };
  const fCloseSalesGroupEmployeeModal = (e) => {
    setSalesGroupEmployeeModal(false);
    setTimeout(() => {
      document.getElementsByName("EmployeeName")[0]?.focus();
    }, 100);
  };
  //GCEmployeeSearch
  const fEmployeeSearchEnter = (e) => {
    if (e.key == "Enter") {
      GetEmployeeSearchVanGroup(sSalesGroupEmployeeModelObj.AnyData);
    }

    if (e.key == "ArrowDown" || e.keyCode == 40) {
      var selectedLength =
        document.getElementsByClassName("Mui-selected").length;
      setTimeout(() => {
        if (selectedLength === 0) {
          let tabel = document.getElementById("table-main-grid-6");
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            .firstChild?.focus();
        }
      }, 200);
    }
  };
  const fonChangeInputEmployeeModal = (event) => {
    setSalesGroupEmployeeModelObj((obj) => ({
      ...obj,
      [event.target.name]: event.target.value,
    }));
  };
  //GCEmployeeSearch
  const fEmployeeRowClick = (e, x) => {
    setSalesGroupModalObj((obj) => ({
      ...obj,
      EmployeeID: e?.row?.EMPID,
      EmployeeName: e?.row?.SName,
      Active: e?.row?.InActive,
    }));
    fCloseSalesGroupEmployeeModal();
  };

  //GCEmployeeSearch
  const fEmployeeRowCellClick = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      setSalesGroupModalObj((obj) => ({
        ...obj,
        EmployeeID: newSelectionModel?.row?.EMPID,
        EmployeeName: newSelectionModel?.row?.SName,
        Active: newSelectionModel?.row?.InActive,
      }));
      fCloseSalesGroupEmployeeModal();
    }
  };

  const fClearEmployeeSearch = () => {
    setSalesGroupEmployeeModelObj((obj) => ({
      ...obj,
      AnyData: "",
      FirstName: "",
      MiddleName: "",
      LastName: "",
    }));
    setEmployeeSearchResultArr([]);
  };

  const fOpenSalesGroupModal = async () => {
    // setSalesGroupModal(true);
    if (sDetail.VocNo !== 0 && sDetail.SalesGroupCode !== "") {
      let vFillVanMaster = await GetFillVanMaster();
      if (vFillVanMaster.toUpperCase() === "SUCCESS") {
        setSalesGroupModal(true);
        GetVANMastItemList();
        setSalesGroupModalObj((obj) => ({
          ...obj,
          Group: sDetail.SalesGroupCode,
        }));
        setTimeout(() => {
          document.getElementsByName("EmployeeName")[0]?.focus();
        }, 100);
      } else {
        fAlertToast("FAILED", "FillVanMaster not Saved ");
      }
    } else {
      fAlertToast("FAILED", "VocNo and Sales Group shouldn't be Empty ");
    }
  };

  //API WMTransSalesGroupDetail_GETROW
  const GetCartBarcodeDetail = async (xscan) => {
    const CartBarcodeDetailObj = {
      v_TrnsId: xscan,
    };
    const CartBarcodeDetail = await fExecuteAPI(
      "WMTransSalesGroupDetail_GETROW",
      CartBarcodeDetailObj
    );
    if (CartBarcodeDetail?.Type?.toUpperCase() === "SUCCESS") {
      if (CartBarcodeDetail.ResultSet.length > 0) {
        let CardDetail = CartBarcodeDetail.ResultSet[0];
        setDetail((obj) => ({
          ...obj,
          VocType: CardDetail.VocTypeCode,
          VocName: CardDetail.VocTypeName,
          VocNo: CardDetail.VocNo,
          LocCode: CardDetail.LocCode,
          LocName: CardDetail.LocName,
          BrCode: CardDetail.BrCode,
          BrName: CardDetail.BrName,
          SalesGroup: CardDetail.SalesGroupName,
          SalesGroupCode: CardDetail.SalesGroupCode,
          LoadingStatus: CardDetail.LoadingStatus,
          DocStatus: CardDetail.LoadingStatus,
        }));
        return CartBarcodeDetail.ResultSet;
      } else {
        setDetail((obj) => ({
          ...obj,
          VocType: "",
          VocName: "",
          VocNo: "",
          LocCode: "",
          LocName: "",
          BrCode: "",
          BrName: "",
          SalesGroup: "",
          SalesGroupCode: "",
          LoadingStatus: "",
          DocStatus: "",
        }));
        setSalesGroup([]);
        fAlertToast("WARNING", "Wrong Scan ID");
        return [];
      }
    } else if (CartBarcodeDetail.Type === "FAILED") {
      fAlertToast("FAILED", CartBarcodeDetail.Message);
      return [];
    } else if (
      CartBarcodeDetail.response.status == 500 ||
      CartBarcodeDetail.response.status == 400
    ) {
      fAlertToast("FAILED", CartBarcodeDetail.response.data.message);
      return [];
    } else {
      fAlertToast("FAILED", "Error");
      return [];
    }
  };

  //API SALESGROUP
  const GetSalesGroups = async (xA_Loc) => {
    const vSalesGroup = await fExecuteAPI("SALESGROUPS_GETROW", xA_Loc);
    if (vSalesGroup?.Type?.toUpperCase() === "SUCCESS") {
      if (vSalesGroup.ResultSet.length > 0) {
        setSalesGroup(vSalesGroup.ResultSet);
        return vSalesGroup.ResultSet;
      } else {
        setSalesGroup([]);
        return [];
      }
    } else if (
      vSalesGroup.response.status == 500 ||
      vSalesGroup.response.status == 400
    ) {
      fAlertToast("FAILED", vSalesGroup.response.data.Status);
      setSalesGroup([]);
      return [];
    } else {
      fAlertToast("FAILED", "Error in loading SalesGroupArr");
      setSalesGroup([]);
      return [];
    }
  };

  //API FillVanMaster_GETROW
  const GetFillVanMaster = async () => {
    let vFillVanMasterObj = {
      VocTyp: sDetail.VocType,
      VocNo: sDetail.VocNo,
      SalesGroup: sDetail.SalesGroupCode,
      Flag: "Y",
    };
    const vFillVanMaster = await fExecuteAPI(
      "FillVanMaster_GETROW",
      vFillVanMasterObj
    );
    if (vFillVanMaster.Type == "SUCCESS") {
      // let GridID = vFillVanMaster.ResultSet?.map((obj, i) => ({ ...obj, id: i + 1 }))

      return vFillVanMaster.Type;
    } else if (vFillVanMaster.Type == "FAILED") {
      fAlertToast("FAILED", vFillVanMaster.Message);
      return vFillVanMaster.Type;
    } else if (
      vFillVanMaster.response.status == 500 ||
      vFillVanMaster.response.status == 400
    ) {
      fAlertToast("FAILED", vFillVanMaster.response.data.Status);
      return vFillVanMaster.Type;
    } else {
      fAlertToast("FAILED", "Error in loading FillVanMaster");
      return vFillVanMaster.Type;
    }
  };
  //API EmployeeSearchVanGroup_GETROW
  const GetEmployeeSearchVanGroup = async (xAnyData) => {
    let vEmployeeSearchVanGroupObj = {
      v_AnyData: xAnyData,
      v_FName: sSalesGroupEmployeeModelObj.FirstName,
      v_LName: sSalesGroupEmployeeModelObj.LastName,
      v_MName: sSalesGroupEmployeeModelObj.MiddleName,
      v_UserCd: vRdxuserInfo.UserID,
    };
    const vEmployeeSearchVanGroup = await fExecuteAPI(
      "EmployeeSearchVanGroup_GETROW",
      vEmployeeSearchVanGroupObj
    );
    if (vEmployeeSearchVanGroup.Type == "SUCCESS") {
      let GridID = vEmployeeSearchVanGroup.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setEmployeeSearchResultArr(GridID);
    } else if (vEmployeeSearchVanGroup.Type == "FAILED") {
      fAlertToast("FAILED", vEmployeeSearchVanGroup.Message);
    } else if (
      vEmployeeSearchVanGroup.response.status == 500 ||
      vEmployeeSearchVanGroup.response.status == 400
    ) {
      fAlertToast("FAILED", vEmployeeSearchVanGroup.response.data.Status);
    } else {
      fAlertToast("FAILED", "Error in loading EmployeeSearchVanGroup");
    }
  };
  //API WMINV08VANMastItemSave_GETROW
  const GetVANMastItemSave = async () => {
    let vSaveSaleGroupModalObj = {
      v_VocTyp: sDetail.VocType,
      v_VocNo: sDetail.VocNo,
      v_UId: sDetail.SalesGroupCode,
      v_SrNo: sSalesGroupModalObj.SrNo,
      v_Typ: sSalesGroupModalObj.Type,
      v_EMPID: sSalesGroupModalObj.EmployeeID,
      v_UserCd: vRdxuserInfo.UserID,
      v_Ip: vRdxuserInfo.IP,
      v_Active: sSalesGroupModalObj.Active,
    };
    const vSaveSaleGroupModal = await fExecuteAPI(
      "WMINV08VANMastItemSave_GETROW",
      vSaveSaleGroupModalObj
    );
    if (vSaveSaleGroupModal?.Type?.toUpperCase() == "SUCCESS") {
      fAlertToast("SUCCESS", "Successfully Saved");
      fNewSaleGroupModal();
    } else if (vSaveSaleGroupModal?.Type?.toUpperCase() == "FAILED") {
      fAlertToast("FAILED", vSaveSaleGroupModal.Message);
    } else if (
      vSaveSaleGroupModal.response.status == 500 ||
      vSaveSaleGroupModal.response.status == 400
    ) {
      fAlertToast("FAILED", vSaveSaleGroupModal.response.data.Status);
    } else {
      fAlertToast("FAILED", "Error in loading SaveSaleGroupModal");
    }
  };

  //API WMINV08VANMastItemDelete_GETROW
  const GetVANMastItemDelete = async () => {
    let vDeleteSaleGroupModalObj = {
      v_VocTyp: sDetail.VocType,
      v_VocNo: sDetail.VocNo,
      v_UId: sDetail.SalesGroupCode,
      v_SrNo: sSalesGroupModalObj.SrNo,
    };
    const vDeleteSaleGroupModal = await fExecuteAPI(
      "WMINV08VANMastItemDelete_GETROW",
      vDeleteSaleGroupModalObj
    );
    if (vDeleteSaleGroupModal?.Type?.toUpperCase() == "SUCCESS") {
      fAlertToast("SUCCESS", "Successfully Deleted");
      fNewSaleGroupModal();
    } else if (vDeleteSaleGroupModal?.Type?.toUpperCase() == "FAILED") {
      fAlertToast("FAILED", vDeleteSaleGroupModal.Message);
    } else if (
      vDeleteSaleGroupModal.response.status == 500 ||
      vDeleteSaleGroupModal.response.status == 400
    ) {
      fAlertToast("FAILED", vDeleteSaleGroupModal.response.data.Status);
    } else {
      fAlertToast("FAILED", "Error in loading DeleteSaleGroupModal");
    }
  };

  //API WMINV08VANMastItemList_GETROW
  const GetVANMastItemList = async () => {
    let vVANMastItemListObj = {
      v_VocTyp: sDetail.VocType,
      v_VocNo: sDetail.VocNo,
      v_UID: sDetail.SalesGroupCode,
    };
    const vVANMastItemList = await fExecuteAPI(
      "WMINV08VANMastItemList_GETROW",
      vVANMastItemListObj
    );
    if (vVANMastItemList.Type == "SUCCESS") {
      let GridID = vVANMastItemList.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setSalesGroupModalArr(GridID);
    } else if (vVANMastItemList.Type == "FAILED") {
      fAlertToast("FAILED", vVANMastItemList.Message);
    } else if (
      vVANMastItemList.response.status == 500 ||
      vVANMastItemList.response.status == 400
    ) {
      fAlertToast("FAILED", vVANMastItemList.response.data.Status);
    } else {
      fAlertToast("FAILED", "Error in loading VANMastItemList");
    }
  };
  //API WMTransSalesGroupUpdate_GETROW
  const GetUpdate = async () => {
    let vUpdateObj = {
      v_VocTyp: sDetail.VocType,
      v_VocNo: sDetail.VocNo,
      userCd: vRdxuserInfo.UserID,
      v_SalesGrp: sDetail.SalesGroupCode,
    };
    const vUpdate = await fExecuteAPI(
      "WMTransSalesGroupUpdate_GETROW",
      vUpdateObj
    );
    if (vUpdate?.Type?.toUpperCase() == "SUCCESS") {
      fAlertToast("SUCCESS", "Successfully Saved");
      fNew();
      document.getElementsByName("Scan")[0]?.focus();
    }
    // else if (vUpdate?.Type?.toUpperCase() == "FAILED") {
    //   fAlertToast("FAILED", vUpdate.Message);
    // } else if (
    //   vUpdate.response.status == 500 ||
    //   vUpdate.response.status == 400
    // ) {
    //   fAlertToast("FAILED", vUpdate.response.data.Status);
    // }
    else {
      fAlertToast("FAILED", vUpdate.message);
    }
  };
  useEffect(() => {
    scanFocusOnLoad.current?.focus();
  }, []);

  const [GridDataColumnsSalesGroupModal, setGridDataColumnsSalesGroupModal] =
    useState(GridDataColumnsSalesGroupModal_Def);

  useEffect(() => {
    GetGitterColumns(
      setGridDataColumnsSalesGroupModal,
      "SALES_GROUP_UPDATE",
      GridDataColumnsSalesGroupModal
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [GridDataColumnsEmployeeModal, setGridDataColumnsEmployeeModal] =
    useState(GridDataColumnsEmployeeModal_Def);

  useEffect(() => {
    GetGitterColumns(
      setGridDataColumnsEmployeeModal,
      "SALES_GROUP_UPDATE_EMPLOYEE",
      GridDataColumnsEmployeeModal
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="container-fluid py-2 ">
      <ToastContainer />
      <div className="container-fluid ">
        <div className="my-2">
          <span className="breadcrumb-not-active ">SalesGroupUpdate </span>
        </div>
      </div>
      <div className="Instantg-picking-detail my-4">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2} columns={{ xs: 12, sm: 12, md: 12 }}>
            <Grid item xs={12} sm={12} md={12}>
              <CmpTextFieldEnter
                xref={scanFocusOnLoad}
                xLabelText={"Scan"}
                xVariant={"outlined"}
                xValue={sDetail.Scan}
                xOnChange={(event) => fOnChangeInput(event)}
                xReadOnly={false}
                xType={"text"}
                xName={"Scan"}
                xOnKeyUp={(e) => {
                  fOnKeyUp(e);
                }}
                xError={sErrorMsg.Scan === "" ? false : true}
                xErrorMessage={sErrorMsg.Scan}
                xOnEnter={(e) => {
                  fOnKeyUp(sEnterKeyObj);
                }}
                xSmShow={!!vMediaQuery}
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4}>
              <CmpTextField
                xLabelText={"VocType"}
                xVariant={"outlined"}
                xValue={sDetail.VocType}
                xOnChange={(event) => fOnChangeInput(event)}
                xReadOnly={true}
                xType={"text"}
                xName={" VocType"}
                xError={sErrorMsg.VocType === "" ? false : true}
                xErrorMessage={sErrorMsg.VocType}
              />
            </Grid>
            <Grid item xs={8} sm={8} md={8}>
              <CmpTextField
                xLabelText={"VocName"}
                xVariant={"outlined"}
                xValue={sDetail.VocName}
                xOnChange={(event) => fOnChangeInput(event)}
                xReadOnly={true}
                xType={"text"}
                xName={"VocName"}
                xError={sErrorMsg.VocName === "" ? false : true}
                xErrorMessage={sErrorMsg.VocName}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <CmpTextField
                xLabelText={"VocNo"}
                xVariant={"outlined"}
                xValue={sDetail.VocNo}
                xOnChange={(event) => fOnChangeInput(event)}
                xReadOnly={true}
                xType={"text"}
                xName={"VocNo"}
                xError={sErrorMsg.VocNo === "" ? false : true}
                xErrorMessage={sErrorMsg.VocNo}
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4}>
              <CmpTextField
                xLabelText={"Location Code"}
                xVariant={"outlined"}
                xValue={sDetail.LocCode}
                xOnChange={(event) => fOnChangeInput(event)}
                xReadOnly={true}
                xType={"text"}
                xName={"LocCode"}
                xError={sErrorMsg.LocCode === "" ? false : true}
                xErrorMessage={sErrorMsg.LocCode}
              />
            </Grid>
            <Grid item xs={8} sm={8} md={8}>
              <CmpTextField
                xLabelText={"Location Name"}
                xVariant={"outlined"}
                xValue={sDetail.LocName}
                xOnChange={(event) => fOnChangeInput(event)}
                xReadOnly={true}
                xType={"text"}
                xName={"LocName"}
                xError={sErrorMsg.LocName === "" ? false : true}
                xErrorMessage={sErrorMsg.LocName}
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4}>
              <CmpTextField
                xLabelText={"Branch Code"}
                xVariant={"outlined"}
                xValue={sDetail.BrCode}
                xOnChange={(event) => fOnChangeInput(event)}
                xReadOnly={true}
                xType={"text"}
                xName={"BrCode"}
                xError={sErrorMsg.BrCode === "" ? false : true}
                xErrorMessage={sErrorMsg.BrCode}
              />
            </Grid>
            <Grid item xs={8} sm={8} md={8}>
              <CmpTextField
                xLabelText={"Branch Name"}
                xVariant={"outlined"}
                xValue={sDetail.BrName}
                xOnChange={(event) => fOnChangeInput(event)}
                xReadOnly={true}
                xType={"text"}
                xName={"BrName"}
                xError={sErrorMsg.BrName === "" ? false : true}
                xErrorMessage={sErrorMsg.BrName}
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4}>
              <CmpTextField
                xLabelText={"Sales GroupCode"}
                xVariant={"outlined"}
                xValue={sDetail.SalesGroupCode}
                xOnChange={(event) => fOnChangeInput(event)}
                xReadOnly={true}
                xType={"text"}
                xName={"SalesGroupCode"}
                xError={sErrorMsg.SalesGroupCode === "" ? false : true}
                xErrorMessage={sErrorMsg.SalesGroupCode}
              />
            </Grid>
            <Grid item xs={8} sm={8} md={8} className="d-flex">
              <CmpSelectBox
                xLabelText="Sales Group"
                xValue={sDetail.SalesGroupCode}
                xOnChange={(event) => fSalesGroupSelect(event)}
                xName={"SalesGroup"}
                xData={sSalesGroup}
                xValueMember={""}
                xDispalyMember={""}
                xError={sErrorMsg.SalesGroup === "" ? false : true}
                xErrorMessage={sErrorMsg.SalesGroup}
                xDisable={false}
              />

              <Button
                variant="outlined"
                className="SaleGroupUpdate "
                sx={{ height: vMediaQuery ? "41px" : "49px" }}
                onClick={fOpenSalesGroupModal}
              >
                <MoreHorizIcon />
              </Button>
            </Grid>

            <Grid item xs={4} sm={6} md={6}>
              <CmpTextField
                xLabelText={"Loading Status"}
                xVariant={"outlined"}
                xValue={sDetail.LoadingStatus}
                xOnChange={(event) => fOnChangeInput(event)}
                xReadOnly={true}
                xType={"text"}
                xName={"LoadingStatus"}
                xError={sErrorMsg.LoadingStatus === "" ? false : true}
                xErrorMessage={sErrorMsg.LoadingStatus}
              />
            </Grid>
            <Grid item xs={8} sm={6} md={6}>
              <CmpTextField
                xLabelText={"Document Status"}
                xVariant={"outlined"}
                xValue={sDetail.DocStatus}
                xOnChange={(event) => fOnChangeInput(event)}
                xReadOnly={true}
                xType={"text"}
                xName={"DocStatus"}
                xError={sErrorMsg.DocStatus === "" ? false : true}
                xErrorMessage={sErrorMsg.DocStatus}
              />
            </Grid>
          </Grid>
        </Box>
        <br></br>
        <Box sx={{ flexGrow: 1 }}>
          <Grid
            container
            spacing={1}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className="text-center"
          >
            <Grid item xs={6}>
              <CmpButton
                xbtnName="Clear"
                xOnClick={fNew}
                xVariant="contained"
                xSize="small"
              />
            </Grid>
            <Grid item xs={6}>
              <CmpButton
                xbtnName="Update"
                xOnClick={fUpdate}
                xVariant="contained"
                xSize="small"
              />
            </Grid>
          </Grid>
        </Box>
      </div>
      <GCVanMaster
        open={sSalesGroupModal}
        fCloseSalesGroupModal={fCloseSalesGroupModal}
        xDocStatus={false}
        xVocNo={sDetail.VocNo}
        xVocType={sDetail.VocType}
        xVocTypeName={sDetail.VocName}
        xSalesGroup={sSalesGroup}
        xSaleGroupTypeArr={sSaleGroupTypeArr}
        xVanMasterModalObj={sSalesGroupModalObj}
        xMediaQuery={vMediaQuery}
        xEnterObj={sEnterKeyObj}
        xGetVanMasterSearchEnter={fGetVanMasterSearchEnter}
        xfOnVanMasterSrNoModal={fOnVanMasterSrNoModal}
        xfOnVanMasterEmployeeModal={fOnVanMasterEmployeeModal}
        xfOnVanMasterActiveModal={fOnVanMasterActiveModal}
        xfNewSaleGroup={fNewSaleGroupModal}
        xfSaveSaleGroup={fSaveSaleGroupModal}
        xfDeleteSaleGroup={fDeleteSaleGroupModal}
        xfOnVanMasterTypModal={fOnVanMasterTypModal}
        xrows={sSalesGroupModalArr}
        xcolumns={GridDataColumnsSalesGroupModal}
        xRowClick={fVanMasterRowClick}
        xRowCellClick={fVanMasterRowCellClick}
        xErrorMsg={sErrorMsgVanMaster}
      />
      <GCEmployee
        open={sSalesGroupEmployeeModal}
        xCloseSearchModal={fCloseSalesGroupEmployeeModal}
        xTitle={"Employee"}
        xAnyData={""}
        xModelObj={sSalesGroupEmployeeModelObj}
        xSearchEnter={fEmployeeSearchEnter}
        xonChangeInputModal={fonChangeInputEmployeeModal}
        xGridArr={sEmployeeSearchResultArr}
        xGridDataColumnsSearch={GridDataColumnsEmployeeModal}
        xRowClick={fEmployeeRowClick}
        xRowCellClick={fEmployeeRowCellClick}
        xClearSimpleSearch={fClearEmployeeSearch}
        xMediaQuery={vMediaQuery}
        xEnterObj={sEnterKeyObj}
      />
    </div>
  );
}
